import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ButtonSecondary, ButtonTertiary } from '../button';
import {
    getCookieConsent,
    initAnalyticsFromConsent,
    setCookieConsent,
} from '../../services/analytics';
import './CookieBanner.scss';

const CookieBanner: React.FC = () => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (getCookieConsent() === null) {
            setVisible(true);
        } else {
            initAnalyticsFromConsent();
        }
    }, []);

    const handleAccept = () => {
        setCookieConsent('accepted');
        setVisible(false);
    };

    const handleReject = () => {
        setCookieConsent('rejected');
        setVisible(false);
    };

    if (!visible) {
        return null;
    }

    return (
        <div className="cookie-banner" role="dialog" aria-live="polite" aria-label={t('cookies.title')}>
            <div className="cookie-banner__inner">
                <p className="cookie-banner__text">
                    {t('cookies.message')}{' '}
                    <Link to="/legal/privacy" className="cookie-banner__link">
                        {t('cookies.privacy_link')}
                    </Link>
                </p>
                <div className="cookie-banner__actions">
                    <ButtonTertiary type="button" size="sm" onClick={handleReject}>
                        {t('cookies.reject')}
                    </ButtonTertiary>
                    <ButtonSecondary type="button" size="sm" onClick={handleAccept}>
                        {t('cookies.accept')}
                    </ButtonSecondary>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
